import { connect } from 'react-redux';
import modal from 'decorators/Modal/Modal';
import { withSagas } from 'decorators/Sagas/Sagas';
import { decorateWith, withName } from 'helpers/decorator';
import { scheduleById, userActionCampaignEvent } from 'redux/saga/entities/bound';
import { cleanupInviteAFriendModal, loadReferralCampaign } from './InviteAFriendModal.saga';
import { InviteAFriendModal } from './InviteAFriendModal';
export var mapStateToProps = function mapStateToProps(state, _ref) {
  var scheduleId = _ref.scheduleId;
  return {
    isLoading: scheduleById.loading(state, scheduleId) || userActionCampaignEvent.loading(state, userActionCampaignEvent.lastRequestedKey(state)),
    referral: userActionCampaignEvent.data(state, userActionCampaignEvent.lastRequestedKey(state)),
    schedule: scheduleById.data(state, scheduleId)
  };
};
export var InviteAFriendModalContainer = decorateWith(modal(), withSagas({
  cleanup: cleanupInviteAFriendModal,
  load: loadReferralCampaign
}), connect(mapStateToProps), withName('InviteAFriendModalContainer'))(InviteAFriendModal);